import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 140,
    height: 'auto',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 450 43.82"
    >
      <defs>
        <clipPath id="saltsquare-clip">
          <path d="M259.05,43Zm150.79,0H450V34H419.59V26.37h22.58v-9H419.59V9.82H450v-9H409.84ZM170.13,30a11,11,0,0,0,2.92,7.86,17.18,17.18,0,0,0,7.41,4.56,30.23,30.23,0,0,0,9.3,1.44q8.53,0,14.15-3.27t5.61-10.78c0-5-1.76-8.38-5.29-10.14S196,17,190.21,17c-1.24,0-2.23,0-3-.06a21.17,21.17,0,0,1-3.27-.45c-2.22-.49-3.34-1.46-3.34-2.95,0-1.76,1-2.95,2.95-3.66a18.44,18.44,0,0,1,6.16-.9,16.23,16.23,0,0,1,6.16,1.09c2.06.85,3.08,2.1,3.08,3.72v.9h9.69v-.9a11.23,11.23,0,0,0-2.76-7.73,16.27,16.27,0,0,0-7.06-4.58A27.71,27.71,0,0,0,189.76,0q-8.14,0-13.5,3.14t-5.36,10.4q0,7.31,5.07,9.88c3.37,1.71,7.87,2.56,13.47,2.56,1.32,0,2.4,0,3.21.07a19.67,19.67,0,0,1,3.53.51c2.38.58,3.59,1.63,3.59,3.21,0,1.84-1.09,3.2-3.27,4a19.15,19.15,0,0,1-6.74,1,18.68,18.68,0,0,1-6.48-1q-3.47-1.29-3.46-3.79v-.83h-9.69ZM0,30a11,11,0,0,0,2.92,7.86,17.29,17.29,0,0,0,7.41,4.56,30.23,30.23,0,0,0,9.3,1.44c5.69,0,10.41-1.1,14.15-3.27s5.61-5.78,5.61-10.78-1.76-8.38-5.29-10.14S25.9,17,20.08,17c-1.24,0-2.23,0-2.95-.06a22.27,22.27,0,0,1-3.27-.45C11.64,16,10.52,15,10.52,13.54c0-1.76,1-3,3-3.66A18.44,18.44,0,0,1,19.63,9a16.23,16.23,0,0,1,6.16,1.09c2.05.84,3.08,2.11,3.08,3.72v.9h9.69v-.9A11.26,11.26,0,0,0,35.8,6.06a16.27,16.27,0,0,0-7.06-4.58A27.67,27.67,0,0,0,19.63,0C14.2,0,9.69,1.05,6.13,3.14S.77,8.7.77,13.54s1.69,8.17,5.07,9.88S13.71,26,19.31,26c1.33,0,2.4,0,3.21.07a18.81,18.81,0,0,1,3.53.51c2.38.58,3.59,1.63,3.59,3.21,0,1.84-1.09,3.2-3.27,4a19.34,19.34,0,0,1-6.74,1,18.91,18.91,0,0,1-6.48-1c-2.3-.86-3.46-2.12-3.46-3.79v-.83H0ZM66.28,10.2l5.58,13.47h-11ZM53.57,43l4-10.32H75.19l4,10.32H89.69L73,.83H60L43.24,43Zm43.07,0h33.1V34H106.39V.83H96.64Zm43.73,0h9.75V9.82h15.59v-9H124.78v9h15.59ZM267,22.71a23.54,23.54,0,0,0,2.31,10.2,19.39,19.39,0,0,0,6.77,7.89,20.1,20.1,0,0,0,21.24,0,19.63,19.63,0,0,0,6.76-7.89,23.35,23.35,0,0,0,2.31-10.17V.83h-9.75V22.71a14,14,0,0,1-1.15,5.62,10.62,10.62,0,0,1-3.4,4.33,9.65,9.65,0,0,1-10.78,0,10.26,10.26,0,0,1-3.4-4.3,14.14,14.14,0,0,1-1.16-5.68V.83H267ZM331.66,10.2l5.58,13.47h-11ZM319,43l4-10.32h17.64L344.62,43h10.45L338.39.83h-13L308.62,43ZM370.33,9.82h19.31a2.71,2.71,0,0,1,2.12.86,3.44,3.44,0,0,1,.77,2.34v1.16a3.46,3.46,0,0,1-.77,2.31,2.68,2.68,0,0,1-2.12.9H370.33Zm0,33.16V26.37h11.74L392,43h11L393.3,27c-.12-.2-.19-.39-.29-.52s-.2-.25-.29-.38a11,11,0,0,0,7.06-4.33,13.16,13.16,0,0,0,2.5-7.93,14.59,14.59,0,0,0-1.44-6.48,11.35,11.35,0,0,0-4.3-4.71,12.94,12.94,0,0,0-6.9-1.77H360.58V43ZM250,9.92H226v24h17.55L252.63,43H216.9V.83h42.15V36.56L250,27.47Z" />
        </clipPath>
        <linearGradient
          id="saltsquare-gradient"
          x1="2.98"
          y1="-69.07"
          x2="468.26"
          y2="121.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#E8436E" />
          <stop offset="0.52" stopColor="#f1636c" />
          <stop offset="1" stopColor="#E8436E" />
        </linearGradient>
      </defs>
      <g clipPath="url(#saltsquare-clip)">
        <rect fill="url(#saltsquare-gradient)" width="450" height="43.82" />
      </g>
    </svg>
  );
};

export default LogoFull;
